import { checkGate, getLayer } from '@eventbrite/statsig';
import {
    RecommendationsEnhancedExperimentVariant,
    RECOMMENDATIONS_ENHANCED_EXPERIMENT,
} from '../constants/statsig';

export const checkEnablePayPalLineItemsFeatureGate = () =>
    checkGate('checkout_enable_paypal_line_items');

export const checkRecommendationsEnhancedExperimentEnabled = () =>
    getLayer(
        RECOMMENDATIONS_ENHANCED_EXPERIMENT.layer,
        RECOMMENDATIONS_ENHANCED_EXPERIMENT.param,
        RECOMMENDATIONS_ENHANCED_EXPERIMENT.defaultValue,
    ) === RecommendationsEnhancedExperimentVariant.leftPaneFollowCard;
